import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { Grid, CardContent, CircularProgress } from "@material-ui/core";
import Card from "components/cards/Card";
import ImageSection from "./product/ImageSection";
import ProductInfo from "./product/ProductInfo";
import { callGetApiWithAuth } from "utils/api";
import RelatedProducts from "./product/RelatedProducts";
import CartBtn from "./miniCart/CartBtn";
import { makeStyles } from "@material-ui/styles";

export default function ProductDetailPage() {
  const { productId } = useParams();
  const history = useHistory();
  const myUser = useSelector((state) => state.auth.user);
  const [product, setProduct] = useState(undefined);
  const [isLoadingProduct, setIsLoadingProduct] = useState(false);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isLoadingRelatedProducts, setIsLoadingRelatedProducts] =
    useState(false);
  const [productType, setProductType] = useState("product");
  const [showInventoryBtn, setShowInventoryBtn] = useState(true);
  const [showCheckoutBtn, setShowCheckoutBtn] = useState(false);
  const classes = useStyles();

  const [productVariant, setProductVariant] = useState(undefined);
  const [productVariantDetails, setProductVariantDetails] = useState(undefined);
  const [size, setSize] = useState(undefined);

  useEffect(() => {
    if (!myUser) return;
    if (myUser.type == 2 && !myUser.shipping_detail) {
      history.push("/shop/enrollee");
      return;
    }
    loadProduct();
    if (history?.location?.state?.query?.type) {
      setProductType(history.location.state.query.type);
    }
  }, [myUser, productId]);

  const loadProduct = () => {
    setIsLoadingProduct(true);
    setProduct(undefined);
    setRelatedProducts([]);
    setIsLoadingRelatedProducts(true);
    callGetApiWithAuth(`shop/products/${productId}`, onGetProduct, () =>
      setIsLoadingProduct(false)
    );
    callGetApiWithAuth(`shop/products`, onGetRelatedProducts);
  };
  const onGetProduct = (data) => {
    setProduct(data.data);
    let variant_ids = [];

    data.data?.variants?.map((ol, index) => {
      if (index === 0) {
        setSize(ol.variant);
        setProductVariantDetails(ol);
      }
      variant_ids.push(ol.variant);
    });
    setProductVariant(variant_ids);
    setTimeout(() => {
      setIsLoadingProduct(false);
    }, 1200);
  };

  const onGetRelatedProducts = (data) => {
    let allProducts = [];
    data.data?.products?.map((el) => {
      if (el.id != productId && allProducts.length <= 3) {
        allProducts.push(el);
      }
    });
    setRelatedProducts(allProducts);
    setTimeout(() => {
      setIsLoadingRelatedProducts(false);
    }, 1200);
  };

  return (
    <>
      {!isLoadingProduct ? (
        <>
          <Card contentStyle={classes.card1}>
            <Grid container spacing={3}>
              <Grid
                xs={12}
                md={6}
                lg={6}
                sm={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ImageSection
                  product={product}
                  productVariantDetails={productVariantDetails}
                />
              </Grid>
              <Grid
                xs={12}
                md={6}
                lg={6}
                sm={6}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ProductInfo
                  product={product}
                  productType={productType}
                  showInventoryBtn={showInventoryBtn}
                  showCheckoutBtn={showCheckoutBtn}
                  setShowInventoryBtn={setShowInventoryBtn}
                  setShowCheckoutBtn={setShowCheckoutBtn}
                  productVariant={productVariant}
                  productVariantDetails={productVariantDetails}
                  size={size}
                  setProductVariantDetails={setProductVariantDetails}
                  setSize={setSize}
                />
              </Grid>
              <Grid xs={12}>
                <div className={classes.line} />
              </Grid>
              <Grid xs={12}>
                <RelatedProducts relatedProducts={relatedProducts} />
              </Grid>
            </Grid>
            <CartBtn
              showInventoryBtn={showInventoryBtn}
              showCheckoutBtn={showCheckoutBtn}
              setShowInventoryBtn={setShowInventoryBtn}
              setShowCheckoutBtn={setShowCheckoutBtn}
            />
          </Card>
        </>
      ) : (
        <div className={classes.loadingRoot}>
          <CircularProgress size={48} />
        </div>
      )}
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  loadingRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // position: "absolute",
    // left: 0,
    // top: 0,
    width: "100%",
    height: "75vh",
  },
  line: {
    height: 2,
    marginTop: 50,
    background: "#e9ecf0",
  },
  card1: {
    padding: "24px 24px 24px !important",
    [theme.breakpoints.down("sm")]: {
      padding: "24px 0px !important",
    },
  },
}));
